import { Component, OnInit, Input } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ShellTrackHandlers } from '@cigna/chcp/shared/analytics-util';
import { DialogVideoEmbedComponent } from '@cigna/chcp/shared/ui';
import { DialogWhatIsTempIdComponent } from '../dialog-what-is-temp-id/dialog-what-is-temp-id.component';
import { DialogWamFaqComponent } from '../dialog-wam-faq/dialog-wam-faq.component';
import { Params } from '@angular/router';

@Component({
  selector: 'cigna-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
})
export class LoginFormComponent implements OnInit {
  loginForm: FormGroup;
  isSubmitted = false;

  hasWam = true;
  @Input() params: Params | null;

  constructor(
    private formBuilder: FormBuilder,
    private analytics: ShellTrackHandlers,
    public dialog: MatDialog,
  ) {}

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });

    if (
      ['wamerror', 'nowam', 'deny'].includes(this.params?.status?.toLowerCase())
    ) {
      this.loginForm.controls.username.markAsTouched();
      this.loginForm.controls.password.markAsTouched();
    }
  }

  openWhatIsTemporaryIdModal() {
    this.dialog.open(DialogWhatIsTempIdComponent, {
      autoFocus: false,
      width: '600px',
    });
  }

  openHowToRegisterModal() {
    this.dialog.open(DialogVideoEmbedComponent, {
      autoFocus: false,
      width: '900px',
      data: {
        title: 'How to register',
        id: '6f82d46ea8f0476096a7df762d490bb1',
        player: 'limelight',
        width: 800,
        height: 475,
      },
    });
  }

  openWamFaqModal(hasWam: boolean) {
    this.dialog.open(DialogWamFaqComponent, {
      autoFocus: false,
      width: '900px',
      data: {
        hasWam,
      },
    });
  }

  submit() {
    if (this.loginForm.valid) {
      // special case we are injecting analytics into component  because
      // 1. there is no effect and
      // 2. button click isnt only way to submit form (can also press enter)
      this.analytics.trackEventOther({}, 'Login', 'ac22393', {
        eVar120: 'login-button',
        eVar119: 'US1880995',
      });

      this.username.setValue(this.username.value.toLowerCase());
      this.isSubmitted = true;

      return true;
    }
    this.loginForm.markAllAsTouched();
    return false;
  }

  get username(): FormControl {
    return this.loginForm.get('username') as FormControl;
  }

  get password(): FormControl {
    return this.loginForm.get('password') as FormControl;
  }

  get status(): string {
    return this.params && this.params.status
      ? this.params.status.toLowerCase()
      : '';
  }

  get dateTimeUntil(): string {
    return this.params && this.params.expireTs
      ? new Date(Number(this.params.expireTs)).toLocaleString()
      : '';
  }
}
